import { List } from "immutable";

/** Collapses numeric and GUID path segments to `:id`, and document-delete file names to `:filename`, so requests to different records group together. */
export const httpRoute = (path: string): string =>
  List(path.split("/"))
    .update((segments: List<string>): List<string> =>
      segments.map((segment: string, index: number): string =>
        index === segments.size - 2 && /^delete(?:competency|user|workorder)doc$/i.test(segments.last(""))
          ? ":filename"
          : /^(?:\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i.test(segment)
            ? ":id"
            : segment
      )
    )
    .join("/");
